// @flow
import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import style from './BlackFridayHeader.scss';
import blackFriday from '../../../../assets/img/home/banner-carousel/blackfriday.png';
import blackFridayMobile from '../../../../assets/img/home/banner-carousel/blackfriday-m.png';

type Props = {};

export default class BlackFridayHeader extends Component<Props> {

  render() {
    const backgroundMobile = { backgroundImage: `url(${blackFridayMobile})` };
    const background = { backgroundImage: `url(${blackFriday})` };
    return (
      <Fragment>
        <section className={style.blackFridayHeader} style={backgroundMobile}>
          <div className={style.desktopBackground} style={background}/>
        </section>
        <FormattedMessage id="bestDeals.title">{
          text => <h2 className={style.blackFridayTitle}>{text}</h2>
        }</FormattedMessage>
      </Fragment>);
  }
}

BlackFridayHeader.propTypes = {};



// WEBPACK FOOTER //
// ./src/modules/best-deals/components/BlackFridayHeader/BlackFridayHeader.jsx